import type { IGetTpvTypesParams } from "./types";

export const salesKeys = {
  all: ["salesKeys"] as const,
  tpvTypes: (params?: IGetTpvTypesParams) =>
    [...salesKeys.all, "tpvTypes", params] as const,
}
